/**
 * Directives for module mwApp.packages
 */

/**
 * overlapWith directive <br>
 * Check overlap boundaries
 *
 * @class overlapWith
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc directive
 * @name mwApp/packages.directive:overlapWith
 *
 * @example
 * $scope.segments = [[1,3], [4,8], [15, 25]];
 *
 * @example
 * <form name="form">
 *     From: <input name="from" type="number" min="1" ng-model="from" overlap-with="segments" overlap-bound="to"> <br>
 *     To: <input name="to" type="number" min="{{from+1}}" ng-model="to" overlap-with="segments" overlap-bound="from">
 *     <div class="text-danger">
 *         <div ng-show="form.from.$touched && form.from.$error">
 *             <div ng-show="form.from.$error.overlapWith">From number overlaps with other group</div>
 *             <div ng-show="form.from.$error.overlapBound">Group overlaps with other group</div>
 *         </div>
 *         <div ng-show="form.to.$touched && form.to.$error">
 *             <div ng-show="form.to.$error.min">From number is bigger than To</div>
 *             <div ng-show="form.to.$error.overlapWith">To number overlaps with other group</div>
 *             <div ng-show="form.to.$error.overlapBound">Group overlaps with other group</div>
 *         </div>
 *     </div>
 * </form>
 */
export function overlapWith () {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      segments: '=overlapWith',
      bound: '=overlapBound'
    },
    link: function (scope, _element, _attributes, ngModel) {
      // check own value over segments borders
      ngModel.$validators.overlapWith = function (modelValue) {
        for (var i = scope.segments.length; i--;) {
          if (modelValue >= scope.segments[i][0] &&
              modelValue <= scope.segments[i][1]
          ) {
            return false
          }
        }
        return true
      }

      // check both bounds over segments borders
      ngModel.$validators.overlapBound = function (modelValue) {
        if (scope.bound) {
          for (var i = scope.segments.length; i--;) {
            var min = Math.min(scope.bound, modelValue)
            var max = Math.max(scope.bound, modelValue)
            if ((scope.segments[i][0] > min && scope.segments[i][0] < max) ||
                (scope.segments[i][1] > min && scope.segments[i][1] < max)
            ) {
              return false
            }
          }
        }
        return true
      }
    }
  }
}
